import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import pointsMailHomePageNew from './views/points-mail-home-page-new'
import testDrive from './views/test-drive/test-drive'
import veentDetails from './views/veent-details/veent-details'
import discountDetails from './views/discount-details/discount-details'
import practicalSkillsDetails from './views/practical-skills-details/practical-skills-details'
import makeAnAppointment from './views/make-an-appointment/make-an-appointment'


export default [
  {
    path: RoutePathConstants.NEW_HOUME_PAGE,
    name: 'pointsMailHomePageNew',
    component: pointsMailHomePageNew
  },
  {
    path: RoutePathConstants.TEST_DRIVE,
    name: 'testDrive',
    component: testDrive
  },
  {
    path: RoutePathConstants.VEENT_DETAILS,
    name: 'veentDetails',
    component: veentDetails
  },
  {
    path: RoutePathConstants.DISCOUNT_DETAILS,
    name: 'discountDetails',
    component: discountDetails
  },
  {
    path: RoutePathConstants.PRACTICAL_SKILLS_DETAILS,
    name: 'practicalSkillsDetails',
    component: practicalSkillsDetails
  },
  {
    path: RoutePathConstants.MAKE_AN_APPOINTMENT,
    name: 'makeAnAppointment',
    component: makeAnAppointment
  },
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/routers.js